/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import { useTranslation } from "@web-monorepo/i18next";
import { useParams } from "react-router-dom";
import ConundrumRemoteRenderer from "src/pods/conundrums/components/ConundrumRemoteRenderer";

export default function ConundrumStep() {
  const { mountPoint = "", classId = "", conundrumName = "", stepName = "" } = useParams();
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.toolkit"]);

  if (!ready) return null;
  return (
    <ConundrumRemoteRenderer
      params={{
        mountPoint,
        classId,
        conundrumName,
        stepName,
      }}
    />
  );
}
